module.exports = __webpack_public_path__ + "static/media/placement_permissions_toggle_manual_placement.92ffd51a.mov";